document.addEventListener('DOMContentLoaded', (e) => {
	// method section toggle
	jQuery('#methodology_reveal').click(function () {
		jQuery('#propaganda-read-more').toggle();
	});
});
